module.exports = __webpack_public_path__ + "img/niels-van-der-vlist.b1d75777.jpeg";